import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=631ba06c&scoped=true&"
import script from "./Administrator.vue?vue&type=script&lang=js&"
export * from "./Administrator.vue?vue&type=script&lang=js&"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=631ba06c&lang=less&scoped=true&"
import style1 from "./Administrator.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ba06c",
  null
  
)

export default component.exports